import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2dffecc2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "MyClassRoomViewContainer flex items-center qiguai"
};
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex items-center qiguai mt64"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/eb46b0d6-5f35-7e96-17e7-5258593f955e.png",
  style: {
    "width": "150px"
  }
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mt16",
  style: {
    "color": "#CCCCCC"
  }
}, "请等待老师开课", -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "序号", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "套题名称", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "题型", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "题目数量", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "限时", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "操作", -1));
const _hoisted_12 = {
  class: "ptr"
};
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col flex items-center qiguai mt64"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/eb46b0d6-5f35-7e96-17e7-5258593f955e.png",
  style: {
    "width": "150px"
  }
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mt16",
  style: {
    "color": "#1388ff"
  }
}, "请等待老师开题", -1));
const _hoisted_16 = [_hoisted_14, _hoisted_15];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.roomId == null ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createVNode(_component_el_row, {
    class: "flex items-center",
    style: {
      "font-size": "14px",
      "line-height": "23px",
      "width": "1200px",
      "background": "rgb(250, 250, 250)",
      "font-weight": "bold"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 2,
      class: "flex items-center qiguai"
    }, {
      default: _withCtx(() => [_hoisted_6]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5,
      class: "flex items-center qiguai"
    }, {
      default: _withCtx(() => [_hoisted_7]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5,
      class: "flex items-center qiguai"
    }, {
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      class: "flex items-center qiguai"
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      class: "flex items-center qiguai"
    }, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      class: "flex items-center qiguai"
    }, {
      default: _withCtx(() => [_hoisted_11]),
      _: 1
    })]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tpls, (t, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [t ? (_openBlock(), _createBlock(_component_el_row, {
      class: "flex items-center",
      style: {
        "width": "1200px",
        "background": "white",
        "border-bottom": "solid 1px #e5e7eb",
        "font-size": "14px",
        "color": "#606266"
      },
      key: index
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 2,
        class: "flex items-center qiguai"
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_12, _toDisplayString(index), 1)]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 5,
        class: "flex items-center qiguai"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(t?.tplName), 1)]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 5,
        class: "flex items-center qiguai"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.subjectMap[t?.subject]), 1)]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 4,
        class: "flex items-center qiguai"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(t?.totalQuestionSize), 1)]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 4,
        class: "flex items-center qiguai"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(parseInt(t?.secondTimeLimit / 60)) + "分钟", 1)]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 4,
        class: "flex items-center qiguai"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $event => $options.toExam(t)
        }, {
          default: _withCtx(() => [_createTextVNode("前往答题")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024)) : _createCommentVNode("", true)], 64);
  }), 256)), $data.tpls == null || $data.tpls.length < 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16)) : _createCommentVNode("", true)], 64))]);
}